module.exports = __webpack_public_path__ + "img/undraw_medical_research_qg4d.d68d898c.svg";